export const getTopInset = () => {
  const header = document.querySelector('[data-site-header]');
  if (!header || getComputedStyle(header).position !== 'fixed') return 0;

  return Math.max(header.getBoundingClientRect().bottom, 0);
};
